import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../shared/environments/environment';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { IWork, IWorkCreate, IWorkUpdate } from '../typing/work.interface';

@Injectable({
    providedIn: 'root'
})
export class WorkService {

    constructor(private http: HttpClient) {
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IWork>> {
        return this.http.get<IPaginatedResponse<IWork>>(`${environment.API_BASE_PATH}/works`, {params: query});
    }

    getWork(id: number): Observable<IWork> {
        return this.http.get<IWork>(`${environment.API_BASE_PATH}/work/${id}`);
    }

    createWork(work: IWorkCreate): Observable<IWork> {
        return this.http.post<IWork>(`${environment.API_BASE_PATH}/work`, work);
    }

    updateWork(work: IWorkUpdate): Observable<IWork> {
        return this.http.put<IWork>(`${environment.API_BASE_PATH}/work/${work.id}`, work);
    }

    deleteWorks(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/works`, {
            body: data
        });
    }
}
